import { render, staticRenderFns } from "./PlanRenewalSwitchModal.vue?vue&type=template&id=ebbf02ec&"
import script from "./PlanRenewalSwitchModal.vue?vue&type=script&lang=js&"
export * from "./PlanRenewalSwitchModal.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/plan-renewal.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports